import { render, staticRenderFns } from "./zhanlan.vue?vue&type=template&id=6e9ba834&scoped=true&"
import script from "./zhanlan.vue?vue&type=script&lang=js&"
export * from "./zhanlan.vue?vue&type=script&lang=js&"
import style0 from "./zhanlan.vue?vue&type=style&index=0&id=6e9ba834&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9ba834",
  null
  
)

export default component.exports